import React from 'react';
import { Chip, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const Root = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const StyledLink = styled(Link)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  '&:hover': {
    cursor: 'pointer',
  },
})) as typeof Link;

interface Props {
  onClick: () => void;
  onClear: () => void;
  activeCode?: string;
}

export const RedeemCouponButton = ({ onClick, onClear, activeCode }: Props) => {
  const { t } = useTranslation();

  return (
    <Root>
      {activeCode ? (
        <>
          <Chip label={activeCode} variant="outlined" onDelete={onClear} />
        </>
      ) : (
        <StyledLink component={'span'} onClick={onClick}>
          {t('checkout.coupon.redeem_coupon')}
        </StyledLink>
      )}
    </Root>
  );
};
